<template>
    <div>
        <h2>Page Not Found.</h2>
    </div>
</template>
<style scoped>
    div{
        margin-top: 10rem;
        width: 100%
    }
    h2{
        text-align: center
    }
</style>